import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_157_qc_approve: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Quality check approval",
    BindValue: "con_vehicle_approval",
    style: {
      // backgroundColor: "#F1F8E9",
    },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "qc_approval_add",
        columnNumber: "m1 t1 w1",
        TableName: "service_qc_approval",
        DisplayName: "QC Approval",
        Workflow: "service",
        DisableSubmit: true,
        BindValue: "qc_approve_add",
        SubmitActions: [
          {
            Action: "Navigate",
            Navigate: "modulev1/vehicleinsummary",
          },
        ],
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          padding: 10,
        },
        Fields: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
              gap: 8,
            },
            childComponents: [
              
              {
                componentType: ComponentType.BUTTON,
                name: "Edit",
                Label: "Edit",
                BindValue: "btn_Edit",
                onPressAction: "edit",
                ScreenId: "157",
                ActionType: "Edit",
                LockBinding: true,
                Enabled: {
                  Enable: {
                    Json_Attribute: "current_state",
                    values: [
                      "Estimated",
                      "Job card",
                      "Approved",
                      "Rejected",
                      "Put on hold",
                    ],
                  },
                  Mode: ["View"],
                },
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "lock",
                Label: "lock",
                BindValue: "lock",
                onPressAction: "unlock",
                ScreenId: "157",
                ActionType: "Unlock",
                LockBinding: true,
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "QC approval details",
            BindValue: "con_approval_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "QC approval No.",
                PlaceHolder: "Will be auto generated...",
                IsMandatory: false,
                BindValue: "txt_approved_number",
                Json_Attribute: "qc_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "QCAP_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "VIN No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "parentid",
                Json_Attribute: "parent_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                IsReadOnly: true,
                LookupName: "qc_vin_no",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "QC approve status",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "qc_approve_status",
                Json_Attribute: "qc_approve_status",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "QC Approve",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Closed job card",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "file_closed_jobcard",
                Json_Attribute: "closed_jobcard_attachment",
                componentType: ComponentType.FILES,
                showInSummary: false,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Others",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "file_others",
                Json_Attribute: "Others_attachment",
                componentType: ComponentType.FILES,
                showInSummary: false,
                IsVerticalView: true,
              },
              {
                Label: "",
                BindValue: "qc_details",
                componentType: ComponentType.REPORT,
                IncludeLabel: true,
                Settings: "qc_approval",
                Parent_Field: "parentid",
              },
            ],
          },
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              marginTop: 16,
              gap: 8,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "Submit",
                Label: "Submit",
                BindValue: "btn_submit",
                onPressAction: "save",
                ScreenId: "157",
                ActionType: "Add",
                Enabled: {
                  Enable: {
                    Json_Attribute: "current_state",
                    values: [
                      "Estimated",
                      "Job card",
                      "Approved",
                      "Rejected",
                      "Put on hold",
                    ],
                  },
                  Mode: ["Edit", "Add"],
                },
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Cancel",
                Label: "Cancel",
                BindValue: "btn_cancel",
                onPressAction: "navigate",
                Navigate: "modulev1/vehicleinsummary",
                ActionType: "Navigate",
                style: {
                  backgroundColor: "var(--secondary-gray)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
